module.exports = "pegasus/assets/themelp1/webinar/104.png";